<template>
    <div>
        <wv-panel title="">
            <wv-cell title="消息设置" is-link to="/page/setnews">
                <img src="../../assets/img/legal.png" alt="" slot="icon" class="cell-icon"  style="margin-top:6px;width:20px">
            </wv-cell>
            <wv-cell v-if="isBind" title="微信解绑" is-link to="/page/setlock">
                <img src="../../assets/img/lock.png" alt="" slot="icon" class="cell-icon"  style="margin-top:6px;width:20px">
            </wv-cell>
             <wv-cell v-if="!isBind" title="微信绑定" is-link @click="bindwechat()">
                <img src="../../assets/img/lock.png" alt="" slot="icon" class="cell-icon"  style="margin-top:6px;width:20px">
            </wv-cell>
         </wv-panel>

    </div>
</template>

<script>
import thumb from "../../assets/logo.png";
export default {
  name: "setlist",
  data: function() {
    return {
      isBind: false
    };
  },
  mounted: function() {
      this.CheckBindWechat();
  },
  methods: {
    CheckBindWechat: function() {
      this.$http
        .get(this.GLOBAL.BASE_URL + "api/login/checkbindwechat", {
          params: {}
        })
        .then(
          function(d) {
            var rep = JSON.parse(d.bodyText);
            if (rep.Success) {
              this.isBind = rep.Data;
            } else {
              Toast.fail(rep.Message);
            }
          },
          function(d) {
            console.log(d);
          }
        );
    },
    bindwechat:function(){
        window.location.href="https://open.weixin.qq.com/connect/oauth2/authorize?appid="+this.GLOBAL.appid+"&redirect_uri="+this.GLOBAL.redirect_uri+"%23%2Fapp%2Fhome&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect";
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/set/setlist.vue